var map = {
	"./Sleip_Logo_RGB.svg": 11713,
	"./add_circle-24px.svg": 5865,
	"./backup-24px.svg": 30,
	"./camera-24px.svg": 62065,
	"./check-circle-24px.svg": 56416,
	"./check-verified-02.svg": 46744,
	"./chevron_right-24px.svg": 23074,
	"./dangerous-24px.svg": 78538,
	"./dns-24px.svg": 35130,
	"./free_breakfast-24px.svg": 72824,
	"./highlight_off_black-24px.svg": 50872,
	"./horse-head-24.svg": 72445,
	"./horse-head-solid.svg": 40662,
	"./insights-24px.svg": 47744,
	"./lock-24px.svg": 56778,
	"./mars-solid.svg": 32449,
	"./menu-24px.svg": 72108,
	"./multiline_chart-24px.svg": 8768,
	"./notifications-24px.svg": 17457,
	"./person_outline-24px.svg": 32133,
	"./settings-24px.svg": 8181,
	"./sleip-icn.svg": 95778,
	"./sleip-logo-24.svg": 12353,
	"./sleip-logo-dark.svg": 32747,
	"./sleip-logo.svg": 77125,
	"./sleip-white.svg": 17782,
	"./sync_alt-24px.svg": 81982,
	"./toll-24px.svg": 90582,
	"./venus-solid.svg": 22710,
	"./visibility-24px.svg": 17458,
	"./warning-24px.svg": 7223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63169;